import { Component, forwardRef, inject, input } from '@angular/core';
import {
  BuildingPickListItemDto,
  BuildingService
} from '@artemis-software/wr-api';
import { currentTenantId } from '@/utils/admin-utils';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import {
  AssignmentType,
  UnpaginatedPickListBehaviour,
} from '@shared/form-controls/generic-pick-list/generic-pick-list.component';

@Component({
  standalone: false,
  selector: 'wr-team-building-pick-list',
  templateUrl: './team-building-pick-list.component.html',
  styleUrls: ['./team-building-pick-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TeamBuildingPickListComponent),
      multi: true,
    },
  ],
})
export class TeamBuildingPickListComponent extends AbstractFormControl<BuildingPickListItemDto[]> implements UnpaginatedPickListBehaviour<BuildingPickListItemDto> {

  readonly buildingService = inject(BuildingService);
  readonly router = inject(Router);

  readonly getAssignmentTypeFunction = input.required<(building: BuildingPickListItemDto) => AssignmentType>();

  readonly currentTenantId = currentTenantId();

  isPaginated = false as const;

  async getAllItems(): Promise<BuildingPickListItemDto[]> {
    const tenantId = this.currentTenantId();
    if (!tenantId) {
      return [];
    }
    return firstValueFrom(this.buildingService.pickListByOwnerTenant(tenantId));
  }

  getAssignmentType(item: BuildingPickListItemDto): AssignmentType {
    return this.getAssignmentTypeFunction()(item);
  }

  getDisplayName(item: BuildingPickListItemDto): string {
    return item.baseData.sectionText || 'Kein Name vergeben';
  }

  getFirstAdditionalInfo(item: BuildingPickListItemDto): string {
    return item.internalNumber;
  }

  getSecondAdditionalInfo(item: BuildingPickListItemDto): string {
    const area = item.baseData?.area;

    if (area == null) {
      return 'Keine Angabe';
    }

    const formatted = new Intl.NumberFormat('de-AT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(area);

    return `${formatted} m²`;
  }

  getThirdAdditionalInfo(item: BuildingPickListItemDto): string {
    return item.teamName ?? 'Kein Team';
  }

  getSearchableFields(item: BuildingPickListItemDto): string[] {
    return [
      item.baseData.sectionText ?? '',
      item.internalNumber ?? '',
    ];
  }

  showToggleAssignedFromOthers(): boolean {
    return true;
  }

}
